import { ItemGroupConfiguration, ProductUuid } from '@conveyr/shared-types';
import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export interface ItemGroupConfigurationRequest {
    name: string | null
    quantity: number
    type: 'box' | 'pallet'
    lengthMm: number
    widthMm: number
    heightMm: number
    weightGm: number
}

export default (axios: AxiosInstance = baseAxios): { fetchConfigurations: (productUuids: ProductUuid[]) => Promise<ItemGroupConfiguration[]>; createConfiguration: (itemId: number, data: ItemGroupConfigurationRequest) => Promise<ItemGroupConfiguration>; updateConfiguration: (itemId: number, configurationId: number, data: ItemGroupConfigurationRequest) => Promise<ItemGroupConfiguration>; deleteConfigurations: (itemId: number, configurationId: number) => Promise<void>; } => ({
    fetchConfigurations: async (productUuids: ProductUuid[]): Promise<ItemGroupConfiguration[]> => {
        let uri = '/api/inventory/group-configurations?';
        productUuids.forEach(productUuid => uri += `product_uuids[]=${productUuid}&`);

        const response = await axios.get<{ data: ItemGroupConfiguration[] }>(uri);

        return response.data.data;
    },

    createConfiguration: async (itemId: number, data: ItemGroupConfigurationRequest): Promise<ItemGroupConfiguration> => {
        const response = await axios.post<{ data: ItemGroupConfiguration }>(`/api/inventory/${itemId}/group-configurations`, data);

        return response.data.data;
    },

    updateConfiguration: async (itemId: number, configurationId: number, data: ItemGroupConfigurationRequest): Promise<ItemGroupConfiguration> => {
        const response = await axios.patch<{ data: ItemGroupConfiguration }>(`/api/inventory/${itemId}/group-configurations/${configurationId}`, data);

        return response.data.data;
    },

    deleteConfigurations: async (itemId: number, configurationId: number): Promise<void> => {
        return await axios.delete(`/api/inventory/${itemId}/group-configurations/${configurationId}`);
    },
});
